// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"44":"component---src-pages-review-tsx","183":"component---src-pages-submit-tsx","218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"44":"06d7ef14a27ac8612d82","183":"76c017a6104f86b4e5f2","218":"6496d4064c6bc5941586","691":"66178c4f626091619697"}[chunkId] + ".js";
};